<h2 mat-dialog-title>
  {{ titleKey | translate }}
</h2>

<mat-dialog-content>
  <p class="procedure-name" *ngIf="isEditMode">
    {{ 'cpt-dialog.procedure' | translate }}: <strong>{{ product?.name }}</strong>
  </p>

  <form [formGroup]="cptForm">
    <mat-form-field appearance="outline" class="full-width" *ngIf="showStudyPicker">
      <mat-label>{{ 'cpt-dialog.study' | translate }}</mat-label>
      <mat-select formControlName="studyEid">
        <mat-option *ngFor="let study of studyOptions" [value]="study.eid">
          {{ study.label }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="cptForm.controls.studyEid.hasError('required')">
        {{ 'cpt-dialog.study-required' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ 'cpt-dialog.current-cpt' | translate }}</mat-label>
      <mat-chip-grid
        #chipList
        required
        [formControl]="chipGridControl"
        [errorStateMatcher]="cptErrorStateMatcher"
      >
        <mat-chip-row
          *ngFor="let picked of pickedProcedures"
          [value]="picked.productId"
          [removable]="!isLoading"
          [matTooltip]="picked.name"
          (removed)="removePickedProcedure(picked.productId)"
        >
          {{ picked.codes.join(', ') }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip-row>
        <mat-chip-row
          *ngFor="let code of looseCodes"
          [value]="code"
          [removable]="!isLoading"
          [matTooltip]="codeName(code)"
          (removed)="removeCptCode(code)"
        >
          {{ code }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip-row>
        <input
          #codeFilterInput
          matInput
          formControlName="cptCodeInput"
          [placeholder]="'cpt-dialog.cpt-placeholder' | translate"
          [matAutocomplete]="autoCode"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [disabled]="isLoading"
          (matChipInputTokenEnd)="onChipInputTokenEnd($event)"
        />
      </mat-chip-grid>
      <mat-autocomplete
        #autoCode="matAutocomplete"
        [autoActiveFirstOption]="optionCount === 1"
        [displayWith]="displayOption"
        (optionSelected)="optionSelected($event)"
      >
        <mat-option *ngIf="isSearching" disabled>
          <mat-spinner class="searching-spinner" diameter="16"></mat-spinner>
          {{ 'cpt-dialog.searching' | translate }}
        </mat-option>
        <mat-option *ngIf="truncatedMatches as truncated" class="top-matches" disabled>
          {{ 'cpt-dialog.top-matches' | translate: { shown: truncated.shown, total: (truncated.total | number) } }}
        </mat-option>
        <mat-option
          *ngFor="let option of filteredCptCode$ | async"
          [value]="option"
          [matTooltip]="option.name ?? ''"
        >
          [{{ option.codes.join(', ') }}] {{ option.name }}
          <span class="option-source" *ngIf="sourceLabelKey(option) as labelKey">· {{ labelKey | translate }}</span>
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="cptForm.controls.cptCodeInput.hasError('invalidProcedureCode')">
        {{ 'cpt-dialog.invalid-cpt' | translate }}
      </mat-error>
      <mat-error *ngIf="cptForm.controls.cptCodeInput.hasError('duplicateProcedureCode')">
        {{ 'cpt-dialog.duplicate-cpt' | translate }}
      </mat-error>
      <mat-error
        *ngIf="cptForm.controls.cptCodeInput.hasError('tooManyProcedureCodes')
          || cptForm.controls.cptCodes.hasError('maxlength')"
      >
        {{ 'cpt-dialog.too-many-cpt' | translate: { max: maxCptCodes } }}
      </mat-error>
      <mat-error *ngIf="cptForm.controls.cptCodes.hasError('required')">
        {{ 'cpt-dialog.cpt-required' | translate }}
      </mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
  <button mat-stroked-button (click)="onCancel()" [disabled]="isLoading">
    {{ 'common.cancel' | translate }}
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="onSubmit()"
    [disabled]="cptForm.invalid || isLoading"
  >
    <mat-spinner diameter="20" *ngIf="isLoading" style="display: inline-block; margin-right: 8px"></mat-spinner>
    {{ 'common.save' | translate }}
  </button>
</mat-dialog-actions>
